import { Breadcrumb } from "flowbite-react";
import MainLayout from "../layouts/MainLayout";
import { HiHome } from "react-icons/hi";


const TestLayout = () => {
    return (
        <MainLayout>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 xl:grid-cols-4 2xl:gap-7.5">
                <h1>Tet Page</h1>
            </div>
        </MainLayout>
    )
}

export default TestLayout;